import { MutationTree } from 'vuex'

import { PaymentMethod } from '@/models'

import { PaymentMethodState } from './state'

export const ADD_ALLOWED_PAYMENT_METHOD = 'ADD_ALLOWED_PAYMENT_METHOD'
export const REMOVE_ALLOWED_PAYMENT_METHOD = 'REMOVE_ALLOWED_PAYMENT_METHOD'
export const UPDATE_ALLOWED_PAYMENT_METHODS = 'UPDATE_ALLOWED_PAYMENT_METHODS'
export const UPDATE_PAYMENT_METHODS = 'UPDATE_PAYMENT_METHODS'

const mutations: MutationTree<PaymentMethodState> = {
  [ADD_ALLOWED_PAYMENT_METHOD] (state, paymentMethod: PaymentMethod) {
    state.allowedPaymentMethods.elements.push(paymentMethod)
  },

  [REMOVE_ALLOWED_PAYMENT_METHOD] (state, id: number) {
    const index = state.allowedPaymentMethods.elements.findIndex((i) => i.id === id)

    if (index >= 0) {
      state.allowedPaymentMethods.elements.splice(index, 1)
    }
  },

  [UPDATE_ALLOWED_PAYMENT_METHODS] (state, paymentMethods: PaymentMethod[]) {
    state.allowedPaymentMethods.elements = paymentMethods
  },

  [UPDATE_PAYMENT_METHODS] (state, paymentMethods: PaymentMethod[]) {
    state.allPaymentMethods.elements = paymentMethods
  }
}

export default mutations
